module.exports = __webpack_public_path__ + "media/images/brasao-pmf-mono-7cfd7c214326f4e04e9c94d924947ed3.png";